import { Typography } from '@mui/material';
import { styled } from '~/themes';

export const StyledPlatformIcon = styled('img')(() => ({
  borderRadius: '50%',
  width: 24,
  height: 24,
}));

export const StyledConnectedIcon = styled('img')(() => ({
  width: 15,
  height: 15,
}));

export const StyledStatusText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'enabled',
})<{ enabled: boolean }>(({ enabled, theme }) => ({
  'display': 'flex',
  'alignItems': 'center',
  'gap': '6px',
  'color': 'rgba(51, 54, 61, 0.40)',
  '& .dot': {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'rgba(51, 54, 61, 0.40)',
  },
  ...(enabled && {
    'color': theme.color.green100,
    '& .dot': {
      backgroundColor: theme.color.green100,
      width: '8px',
      height: '8px',
      borderRadius: '50%',
    },
  }),
}));
